import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

interface Service {
  id: number;
  name: string;
  description: string;
  type: string;
  icon: string;
  url: string;
}

interface ServiceResponse {
  data: {
    services: Service[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class ServiceService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getServices(gsid: number): Observable<ServiceResponse> {
    const headers = new HttpHeaders({
      'cli': 'Web',
      'appversion': '1.5',
      'serviceversion': '2',
      'latitude': '0',
      'longitude': '0',
      'placeType': 'company',
      'placeId': gsid,
      'infoLevel': '2',
      'Authorization': `Bearer ${localStorage.getItem('gstoken') || ''}`
    });

    return this.http.get<ServiceResponse>(`${this.baseUrl}/services/list?cant=20&page=1`, { headers });
  }




}